<template>
    <div class="play-list">
        <ul class="week-list">
            <li v-for="(week, weekIndex) in weekList" :key="week.id" class="week-item">
                <div class="week-item-title" @click="toggleList(week, weekIndex)">
                    <div class="week-item-title-content">
                        <span class="week-item-title-text">第{{ week.weekId }}周</span>
                        <span class="week-item-title-time">{{ dayjs(week.startTime).format('YYYY-MM-DD') }}</span>
                    </div>
                    <img src="../images/chevron-right.png" class="week-item-title-icon" :class="{ 'is-rotated': week.isExpanded }">
                </div>
                <transition name="slide">
                    <ul v-if="week.isExpanded && week.audios.length" class="song-list">
                        <li
                            v-for="(audio, index) in week.audios" 
                            :key="audio.id" 
                            class="song-item" 
                            :class="{ 'is-playing': audio.playing }"
                            @click="handlePlay(week.audios, index)">
                            <div class="song-item-content">
                                <span class="song-item-text">{{audio.bookName}} {{audio.lessonName}}</span>
                                <div class="song-item-content-footer">
                                    <span class="name">{{audio.audioName}}</span>
                                </div>
                            </div>
                            <img
                                v-show="!audio.playing"
                                src="../images/list-play.png"
                                class="song-item-icon"
                            >
                            <img
                                v-show="audio.playing"
                                src="../images/list-pause.png"
                                class="song-item-icon"
                            >
                        </li>
                    </ul>
                </transition>
            </li>
        </ul>
    </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
    name: 'PlayerList',
    props: {
        weekList: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            dayjs,
            playList: [],
            currentSong: {},
        }
    },
    watch: {
        weekList(val) {
            this.playList = val.map(item => ({
                ...item,
                audios: item.audios.map(audio => ({
                    ...audio,
                    playing: false,
                })),
                isExpanded: false,
            }))
        }
    },
    methods: {
        toggleList(week) {
            week.isExpanded = !week.isExpanded
        },
        handlePlay(audios, index) {
            this.$emit('play', {
                audios,
                index,
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.play-list {
    width: 500px;
    padding: 128px 0 100px;
    background: url('../images/list-bg.png') center/100% 100% no-repeat;
}

.week-list {
    width: 350px;
    height: 100%;
    padding: 0;
    margin: 0 auto;
    overflow: auto;
    list-style: none;
}
.week-item {
    margin-bottom: 16px;
}
.week-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    background-color: #FFDC7E;
    border-radius: 12px;
    border: 2px solid #EBBB5F;
}
.week-item-title-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
}
.week-item-title-text {
    font-size: 22px;
    color: #B34230;
}
.week-item-title-time {
    font-size: 20px;
    color: #C26D44;
}
.week-item-title-icon {
    width: 40px;
    height: 40px;
    transition: transform 0.3s ease;


    &.is-rotated {
        transform: rotate(90deg);
    }
}

.song-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 330px;
    padding: 0;
    margin: 8px auto;
    list-style: none;
}
.song-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    background-color: #547BB7;
    border-radius: 12px;
    border: 1px solid #C1D1E7;
    color: #fff;

    &.is-playing {
        background-color: #8B95D0;
        color: #442A79;
    }
}
.song-item-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
    margin-right: 40px;
}
.song-item-text {
    font-size: 20px;
}
.song-item-content-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    color: #AECEDD;
    font-size: 16px;
    text-align: left;

    .name {
        width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.song-item-icon {
    width: 48px;
    height: 48px;
}

/* 动画基础样式 */
.slide-enter-active, .slide-leave-active {
    transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
}
</style>